/* Calculadora de frete própria — cota pelo Vitrine (snippet lb-frete-vitrine). */
(function () {
  var CHAVE = 'lbCep';
  function reais(c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function prazo(o) {
    if (o.prazo_max === 0) return 'Chega hoje';
    if (o.prazo_min === 0 && o.prazo_max === 1) return 'Hoje ou amanhã';
    var d = o.prazo_max === 1 ? 'dia útil' : 'dias úteis';
    return o.prazo_min && o.prazo_min !== o.prazo_max
      ? o.prazo_min + ' a ' + o.prazo_max + ' ' + d : 'até ' + o.prazo_max + ' ' + d;
  }
  function mascara(v) { v = v.replace(/\D/g, '').slice(0, 8); return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; }
  function ler() { try { return localStorage.getItem(CHAVE) || ''; } catch (e) { return ''; } }
  function gravar(c) { try { localStorage.setItem(CHAVE, c); } catch (e) {} }

  function itensProduto(box) {
    var el = box.querySelector('[data-lb-fv-variantes]');
    if (!el) return [];
    var d = JSON.parse(el.textContent);
    var form = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = (form && form.value) || String(d.atual);
    var v = d.v[id] || d.v[String(d.atual)];
    var q = document.querySelector('form[action*="/cart/add"] [name="quantity"]');
    var qtd = Math.max(1, parseInt(q && q.value, 10) || 1);
    return v && v[2] ? [[v[0], qtd, v[1], d.nome]] : [];
  }
  function itensCarrinho() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) {
        return (c.items || []).filter(function (i) { return i.requires_shipping; })
          .map(function (i) { return [i.grams || 0, i.quantity, i.final_price || i.price, i.product_title || '']; });
      });
  }

  function calcular(box) {
    var input = box.querySelector('.lb-fv__cep');
    var res = box.querySelector('.lb-fv__res');
    var cep = input.value.replace(/\D/g, '');
    if (cep.length !== 8) { res.innerHTML = '<p class="lb-fv__msg">Digite um CEP com 8 números.</p>'; input.focus(); return; }
    gravar(cep);
    res.innerHTML = '<p class="lb-fv__msg">Calculando…</p>';
    var origem = box.dataset.lbFv === 'carrinho' ? itensCarrinho() : Promise.resolve(itensProduto(box));
    origem.then(function (itens) {
      if (!itens.length) { res.innerHTML = '<p class="lb-fv__msg">Sem itens para entregar.</p>'; return null; }
      var qs = 'cep=' + cep + itens.map(function (i) { return '&i=' + encodeURIComponent(i.join(',')); }).join('');
      return fetch(box.dataset.url + (box.dataset.url.indexOf('?') < 0 ? '?' : '&') + qs, { mode: 'cors' })
        .then(function (r) { return r.json(); });
    }).then(function (d) {
      if (!d) return;
      var ops = d.opcoes || [];
      if (!ops.length) { res.innerHTML = '<p class="lb-fv__msg">' + (d.erro || 'Não encontramos frete para este CEP. Confira o número ou fale com a gente.') + '</p>'; return; }
      var ul = document.createElement('ul');
      ul.className = 'lb-fv__lista';
      ul.innerHTML = ops.map(function (o) {
        var extra = o.descricao ? ' · ' + o.descricao.replace(/</g, '&lt;') : '';
        return '<li><span class="lb-fv__nome">' + o.nome.replace(/</g, '&lt;') + '<small>' + prazo(o) + extra + '</small></span>' +
          '<strong>' + (o.preco_centavos ? reais(o.preco_centavos) : (o.descricao ? 'A combinar' : 'Grátis')) + '</strong></li>';
      }).join('');
      res.innerHTML = '';
      res.appendChild(ul);
    }).catch(function () {
      res.innerHTML = '<p class="lb-fv__msg">Não deu para calcular agora. Tente de novo em instantes.</p>';
    });
  }

  function iniciar(box) {
    if (box.dataset.lbFvPronto) return;
    box.dataset.lbFvPronto = '1';
    var input = box.querySelector('.lb-fv__cep');
    input.addEventListener('input', function () { input.value = mascara(input.value); });
    box.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); calcular(box); });
    var salvo = ler();
    if (salvo) input.value = mascara(salvo);
  }
  function varrer() { document.querySelectorAll('[data-lb-fv]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer); else varrer();
  // carrinho em gaveta é re-renderizado: só reage quando entra uma calculadora nova
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches('[data-lb-fv]') || n.querySelector('[data-lb-fv]'))) { varrer(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
